import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Dashboard from './pages/dashboard';
import Login from './pages/login';


const AppRouter = () => {
    return (
        <Router>
            <Routes>
                <Route path='/login' element={<Login />} />
                <Route path='/dashboard/' element={<Dashboard />} />
                <Route index element={<Login />} />
            </Routes>
        </Router>
    );
};

export default AppRouter;